import { mapActions, mapGetters, mapMutations } from 'vuex'
import BaseFixedBarCard from '@c/BaseFixedBarCard'
import BaseUnsavedChangesNotificationMixin from '@u/mixins/BaseUnsavedChangesNotificationMixin'

export default {
  components: {
    BaseFixedBarCard
  },
  mixins: [BaseUnsavedChangesNotificationMixin],
  computed: {
    ...mapGetters({
      dossier: 'dossier/getDossier',
      metadata: 'dossier/getDossierMetadata',
      initialMetadata: 'metadata/getInitialMetadata',
      errors: 'auth/getErrors',
      auth: 'auth/getAuth',
      editionMode: 'dossier/getEditionMode',
      leaveRouteByButton: 'dossier/getLeaveRouteByButton',
      leaveRouteByNotification: 'dossier/getLeaveRouteByNotification',
      dossierHasChanged: 'dossier/getHasChanged'
    }),
    errorsIsEmpty() {
      return Object.keys(this.errors).length === 0
    },
    viewMode() {
      return this.$route.meta.display_type ?? 'view'
    }
  },
  methods: {
    ...mapActions({
      processFetchDossierByIdAction: 'dossier/fetchDossierByID'
    }),
    ...mapMutations({
      processSetEditionModeMutation: 'dossier/setEditionMode',
      processSetLeaveRouteByButtonMutation: 'dossier/setLeaveRouteByButton',
      processSetLeaveRouteByNotificationMutation:
        'dossier/setLeaveRouteByNotification'
    }),
    getCleanedPayload() {
      let preparedPayload = Object.assign({}, this.dossier)
      delete preparedPayload.automation_logs
      delete preparedPayload.agent
      delete preparedPayload.funeral_home
      delete preparedPayload.handler
      delete preparedPayload.responsable
      return preparedPayload
    },
    handleBeforeRouteLeave(route_to, route_from, route_next, update_function) {
      if (this.editionMode && !this.leaveRouteByButton) {
        if (this.dossierHasChanged) {
          this.handleUnsavedChangesNotification(
            route_to,
            route_from,
            route_next,
            update_function
          )
          return
        }
        route_next()
      }
      route_next()
    },
    switchEditionMode: function () {
      // pourquoi refetch alors que le dossier revient dans la response du PUT ??
      // if (this.editionMode) {
      //   this.processFetchDossierByIdAction(this.$route.params.id)
      // }
      this.processSetEditionModeMutation(!this.editionMode)
    }
  }
}
